import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	locks: [],
	gateways: [],
	loading: true,
	error: null,
	searchable: true,
	dataLoadingComplete: false
};

const inventorySlice = createSlice({
	name: 'inventory',
	initialState,
	reducers: {
		loadInventoryLocks: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadInventoryLocksSuccess: (state, action) => {
			state.locks = action.payload;
			state.loading = false;
			state.dataLoadingComplete = true;
		},
		loadInventoryLocksError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		loadInventoryGateways: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadInventoryGatewaysSuccess: (state, action) => {
			state.gateways = action.payload;
			state.loading = false;
			state.dataLoadingComplete = true;
		},
		loadInventoryGatewaysError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => {
			return initialState; // Reset state on logout
		});
	}
});

// Export the actions
export const inventoryActions = inventorySlice.actions;

// Export the reducer
export default inventorySlice.reducer;
